// #region imports

// --- Angular
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

// #endregion

@Pipe({
  name: 'highlightWord'
})
export class HighlightWordPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, ...args: any[]): any {
    if (!args) {
      return value;
    }

    let result = value;
    args.forEach((arg) => {
      // Match in a case insensitive maneer
      const re = new RegExp(arg, 'gi');
      const match = result.match(re);

      // If there's a match, wrap the match with the 'mark' tag.
      if (match) {
        result = result.replace(re, '<mark>' + match[0] + '</mark>');
      }
    });

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
